module.exports = __webpack_public_path__ + "master-logo.cfaf8408.svg";